/**
 * @ngdoc overview
 * @name WcResponsiveTableModule
 * @description
 * WcResponsiveTableModule is a collection of internally developed components and extensions which brings responsive behaviour
 * for jquery datatable, this module is also responsible for some features like sorting and filtering of datatable.
 */


angular.module('WcResponsiveTableModule', []);